<script>
import App from '@/pages/layouts/app.vue'
import {Link, router, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Form from '@/pages/customers/_form.vue'
import FormButtons from "@/pages/components/form-buttons.vue";

export default {
  components: {
    App, Link, Card, Form, FormButtons
  },
  props: {
    customerId: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      loading: true,
      stayOnPage: true,
      name: 'Klant',
      customer: {}
    }
  },
  mounted() {
    this.getCustomer();
  },
  methods: {
    submit() {
      this.loading = true;
      let form = this.$refs.form.form;

      $.ajax({
        url: route('api.v1.customers.update', {customer: this.customerId}),
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify(form.data()),
        processData: false,
        success: (response) => {
          let message = 'De wijzigingen zijn opgeslagen';

          if(!this.stayOnPage) {
            router.get(route('customers.index'), {
              'success': message
            });
          } else {
            Helpers.Message.success(message);
            router.reload();
            this.getCustomer();
          }
        },
        error: (response) => Helpers.Form.handleErrors(form, response)
      }).always(() => {
        this.loading = false;
      });
    },

    getCustomer() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.customers.show', {customer: this.customerId}),
        success: (response) => {
          this.name = response.data.name;
          this.customer = response.data;
          this.$refs.form.setCustomer(response.data);
        }
      }).always(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<template>
  <App :title="`${name} bewerken`">
    <form id="customerForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="customerForm"
          :cancel-route="route('customers.index')"
      />
    </template>
  </App>
</template>